export default [
  {
    path: '/',
    name: 'home',
    component: () => lazyLoadView(import('@views/home.vue')),
  },
  {
    path: '/choose-path',
    name: 'choose-path',
    component: () => lazyLoadView(import('@views/00-choose-path.vue')),
  },
  {
    path: '/style-guide',
    name: 'style-guide',
    component: () => lazyLoadView(import('@views/style-guide.vue')),
  },
  // Exploration Routes
  {
    path: '/01-0-exploration-overview',
    name: 'exploration-overview',
    component: () =>
      lazyLoadView(import('@views/01-0-exploration-overview.vue')),
  },
  {
    path: '/01-A-exploration-planning',
    name: 'exploration-planning',
    component: () =>
      lazyLoadView(import('@views/01-A-exploration-planning.vue')),
  },
  {
    path: '/01-B-exploration-drilling',
    name: 'exploration-drilling',
    component: () =>
      lazyLoadView(import('@views/01-B-exploration-drilling.vue')),
  },
  {
    path: '/01-C-resource-model',
    name: 'resource-model',
    component: () => lazyLoadView(import('@views/01-C-resource-model.vue')),
  },
  {
    path: '/01-D-rock-characterization',
    name: 'rock-characterization',
    component: () =>
      lazyLoadView(import('@views/01-D-rock-characterization.vue')),
  },
  // Planning Routes
  {
    path: '/02-00-Planning-Overview',
    name: 'planning-overview',
    component: () => lazyLoadView(import('@views/02-00-planning-overview.vue')),
  },
  {
    path: '/02-01-Planning',
    name: 'planning-locationa',
    component: () =>
      lazyLoadView(import('@/src/router/views/02-A-planning.vue')),
  },
  // Drilling Routes
  {
    path: '/drilling-blast-overview',
    name: 'drilling-blast-overview',
    component: () => lazyLoadView(import('@views/drilling-blast-overview.vue')),
  },
  {
    path: '/drilling-blast',
    name: 'drilling-blast',
    component: () => lazyLoadView(import('@views/drilling-blast.vue')),
  },
  // Material Movement Overview Routes
  {
    path: '/material-movement-overview',
    name: 'material-movement-overview',
    component: () =>
      lazyLoadView(import('@views/material-movement-overview.vue')),
  },
  {
    path: '/material-movement',
    name: 'material-movement',
    component: () => lazyLoadView(import('@views/material-movement.vue')),
  },
  // Survey Monitoring Routes
  {
    path: '/survey-monitoring-overview',
    name: 'survey-monitoring-overview',
    component: () =>
      lazyLoadView(import('@views/survey-monitoring-overview.vue')),
  },
  {
    path: '/survey-monitoring',
    name: 'survey-monitoring',
    component: () => lazyLoadView(import('@views/survey-monitoring.vue')),
  },
  // Page Not Found Routes
  {
    path: '/404',
    name: '404',
    component: require('@views/_404.vue').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading.vue').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout.vue').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
